module.exports = __webpack_public_path__ + "static/img/EMMC-CbAF51gR.e16668e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/EMMC-CbAF51gR.png
// module id = zFbq
// module chunks = 16